import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import RutaProtegida from './components/RutaProtegida';
import Layout from './components/Layout';

import Landing from './pages/Landing';
import Login from './pages/Login';
import Registro from './pages/Registro';
import VerificarCorreo from './pages/VerificarCorreo';
import RecuperarContrasena from './pages/RecuperarContrasena';

import Inicio from './pages/Inicio';
import Cursos from './pages/Cursos';
import MisCursos from './pages/MisCursos';
import DetalleCurso from './pages/DetalleCurso';
import Perfil from './pages/Perfil';

import PanelAdmin from './pages/admin/PanelAdmin';
import AdminProfesores from './pages/admin/AdminProfesores';
import AdminCursos from './pages/admin/AdminCursos';
import AdminReportes from './pages/admin/AdminReportes';

// Si ya esta logueado redirige a su dashboard, si no muestra el landing
function RutaPublicaInicial() {
    const { usuario, cargando } = useAuth();
    if (cargando) return <div className="loader"><div className="spinner" /><span>Cargando...</span></div>;
    if (usuario) {
        return <Navigate to={usuario.rol === 'administrador' ? '/admin' : '/dashboard'} replace />;
    }
    return <Landing />;
}

// Si ya esta logueado en pantallas auth, mandalo al dashboard
function RutaSoloInvitado({ children }) {
    const { usuario, cargando } = useAuth();
    if (cargando) return <div className="loader"><div className="spinner" /><span>Cargando...</span></div>;
    if (usuario) return <Navigate to={usuario.rol === 'administrador' ? '/admin' : '/dashboard'} replace />;
    return children;
}

function App() {
    return (
        <BrowserRouter>
            <AuthProvider>
                <ThemeProvider>
                    <Routes>
                        {/* Publico */}
                        <Route path="/" element={<RutaPublicaInicial />} />
                        <Route path="/login" element={<RutaSoloInvitado><Login /></RutaSoloInvitado>} />
                        <Route path="/registro" element={<RutaSoloInvitado><Registro /></RutaSoloInvitado>} />
                        <Route path="/verificar-correo" element={<VerificarCorreo />} />
                        <Route path="/recuperar-contrasena" element={<RecuperarContrasena />} />

                        {/* App con layout (requiere login) */}
                        <Route element={<RutaProtegida><Layout /></RutaProtegida>}>
                            <Route path="/dashboard" element={<Inicio />} />
                            <Route path="/cursos" element={<Cursos />} />
                            <Route path="/mis-cursos" element={<MisCursos />} />
                            <Route path="/curso/:id" element={<DetalleCurso />} />

                            <Route path="/perfil" element={<Perfil />} />
                            <Route path="/perfil/configuracion" element={<Perfil />} />
                            <Route path="/perfil/seguridad" element={<Perfil />} />
                            <Route path="/perfil/certificados" element={<Perfil />} />

                            {/* Admin */}
                            <Route path="/admin" element={<RutaProtegida soloAdmin><PanelAdmin /></RutaProtegida>} />
                            <Route path="/admin/profesores" element={<RutaProtegida soloAdmin><AdminProfesores /></RutaProtegida>} />
                            <Route path="/admin/cursos" element={<RutaProtegida soloAdmin><AdminCursos /></RutaProtegida>} />
                            <Route path="/admin/reportes" element={<RutaProtegida soloAdmin><AdminReportes /></RutaProtegida>} />
                        </Route>

                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </ThemeProvider>
            </AuthProvider>
        </BrowserRouter>
    );
}

export default App;
